import SectionInfoVO from '../sections/SectionInfoVO';

export enum ProfileBuilder {
  CUSTOM = 'CUSTOM',
  BASIC = 'BASIC'
}

export interface ProfileBaseVO {
  id: string;
  name: string;
  createdDate: Date;
  updatedDate: Date;
  createdBy: string;
  updatedBy: string;
}

export enum ProfileType {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export enum ProfileStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  IN_ACTIVE = 'IN_ACTIVE',
  TRASH = 'TRASH',
  DUPLICATING = 'DUPLICATING'
}

export interface ProfileSettingsVO {
  profileId?: string;
  updatedTs?: number;
  updatedBy?: string;
  docSortType?: string | null;
  draftDocSortType?: string | null;
  profileSettings?: string[];
  widgetList?: string[];
  inviteOnlyAccessDeniedMessage?: string;
}

export default interface ProfileVO extends ProfileBaseVO {
  companyId: string;
  searchName: string;
  description: string;
  type: ProfileType;
  status: ProfileStatus;
  hasUpdate: boolean;
  sections: SectionInfoVO[];
  owners: string[];
  users: string[];
  sharedCount: number;
  viewedCount: number;
  downloadCount: number;
  countProps: { [key: string]: number };
  customURL?: string;
  customURLOption?: 'CUSTOM_DOMAIN' | 'CUSTOM_SUB_DOMAIN';
  projectViewedCount?: number;
  documentViewedCount?: number;
  contentCount?: number;
  projectCount?: number;
  documentCount?: number;
  comments?: number;
  questionnaireViews?: number;
  profilePicture?: string;
  coverPic?: string;
  lastVersionUpdatedOn?: Date;
  lastDraftedOn?: Date;
  defaultCover?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  profileNotes: { [key: string]: any };
  requestAccess?: boolean;
  ndaAccess?: boolean;
  hasPublishedBefore?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  additionalMap?: { [key: string]: any };
  includeWatermark?: boolean;
  defaultExpirationPeriod?: string;
  userDefinedType: string;
  parentId?: string;
  language?: string;

  builderType: ProfileBuilder;
  previewMode?: boolean;
  builderProperties: {
    index: boolean;
    cover: boolean;
  };
  ownedBy: string;

  sharerCount?: number;
  collaboratorCount?: number;
  userTeamType?: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sharedMembersMetaData?: { [key: string]: any };

  duplicateOf: string;

  isLocked?: boolean;
  txtMsg?: string;

  viewerSharingEnabled?: boolean;
  viewerMessagingEnabled?: boolean;
  showIndex?: boolean;
  showProfileUpdates?: boolean;
  showProfileFAQs?: boolean;
  externalName?: string;
  fontUrls?: string[];
  landingPageViewId?: string | null;
  profilesSettingsVO?: ProfileSettingsVO | null;
  profileId?: string;
}

export interface ProfileMetaDataVO {
  accessRequestsCountMap: { [key: string]: number };
  messagesCountMap: { [key: string]: { [key: string]: number } };
  hasUpdateList: string[];
  contentCountMap: { [key: string]: number };
  profileTypeMap: { [key: string]: string };
}
